<template>
    <div>

        <v-dialog light persistent v-model="showPinpad" class="cardUp">
            <v-layout align-center column justify-center :class="'cardStats pa-1 black--text ' + penaltyType"
                style="height:100%">              
                <table v-if="loaded" style="width: 100%">
                    <tr>
                        <td width="100%" class="pa-1" align="center">
                            <strong>INSERISCI PETTORALE</strong>
                        </td>
                    </tr>
                    <tr>
                        <td width="100%" class="pa-1 black--text white"
                            style="border:2px solid red; height: 50px !important; border-radius: 5px;" align="center">
                            <strong class="display-2">{{ pettoraleIns }}</strong>
                        </td>
                    </tr>
                    <tr>
                        <td width="100%" class=" pa-1" align="center" padding="0px">
                            <table style="width: 100%" class="mb-1">
                                <tr>
                                    <td width="33%" class="pa-3 grey lighten-2 black--text" align="center"
                                        @click="insCifra('1')">
                                        <strong class="display-1">1</strong>
                                    </td>
                                    <td width="33%" class="pa-3 grey lighten-2 black--text" align="center"
                                        @click="insCifra('2')">
                                        <strong class="display-1">2</strong>
                                    </td>
                                    <td width="33%" class="pa-3 grey lighten-2 black--text" align="center"
                                        @click="insCifra('3')">
                                        <strong class="display-1">3</strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="33%" class="pa-3 grey lighten-2 black--text" align="center"
                                        @click="insCifra('4')">
                                        <strong class="display-1">4</strong>
                                    </td>
                                    <td width="33%" class="pa-3 grey lighten-2 black--text" align="center"
                                        @click="insCifra('5')">
                                        <strong class="display-1">5</strong>
                                    </td>
                                    <td width="33%" class="pa-3 grey lighten-2 black--text" align="center"
                                        @click="insCifra('6')">
                                        <strong class="display-1">6</strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="33%" class="pa-3 grey lighten-2 black--text" align="center"
                                        @click="insCifra('7')">
                                        <strong class="display-1">7</strong>
                                    </td>
                                    <td width="33%" class="pa-3 grey lighten-2 black--text" align="center"
                                        @click="insCifra('8')">
                                        <strong class="display-1">8</strong>
                                    </td>
                                    <td width="33%" class="pa-3 grey lighten-2 black--text" align="center"
                                        @click="insCifra('9')">
                                        <strong class="display-1">9</strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="33%" class="pa-3 grey lighten-2 black--text" align="center"
                                        @click="insCifra('CANC')">
                                        <strong>CANC</strong>
                                    </td>
                                    <td width="33%" class="pa-3 grey lighten-2 black--text" align="center"
                                        @click="insCifra('0')">
                                        <strong class="display-1">0</strong>
                                    </td>
                                    <td v-if="penaltyType !=='yellow'" width="33%" class="pa-3 green darken-2 white--text" align="center"
                                        @click="insCifra('INVIO')">
                                        <strong>INVIO</strong>
                                    </td>
                                    <td v-if="penaltyType =='yellow'" width="33%" class="pa-3 grey lighten-2 white--text" align="center"
                                        >
                                        <strong></strong>
                                    </td>
                                </tr>
                                

                            </table>
                            <table v-if="penaltyType=='yellow'" style="width: 100%" class="mb-1">
                                <tr >
                                    <td width="50%"  class="pa-3 blue darken-2 white--text" align="center"
                                        @click="insAmmonizionePenalty()">
                                        <strong>ASSEGNA con<br>PENALTY {{ selectedTime }} sec</strong>
                                    </td>
                                    <td width="50%" class="pa-3 green darken-2 white--text" align="center"
                                        @click="insAmmonizioneNOPenalty()">
                                        <strong>ASSEGNA<br>senza PENALTY</strong>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <!--tr>
                        <td width="100%" class=" pa-0" align="left">
                            Ultimi: {{ lastBib }}
                        </td>
                    </tr-->


                </table>
                <v-btn round class="black  white--text" @click="showPinpad = false">CHIUDI</v-btn>
            </v-layout>
        </v-dialog>



        <v-dialog light persistent v-model="showViolations" class="cardUp">
            <v-layout align-center column justify-center :class="'cardStats pa-1 black--text ' + penaltyType"
                style="height:100%">              
                <table v-if="loaded" style="width: 100%">
                    <tr>
                        <td width="100%" class="pa-1" align="center">
                            <strong>INSERISCI VIOLAZIONE - Num: {{ pettoraleIns }}</strong>
                        </td>
                    </tr>
                    
                    
                    <tr>
                        <td width="100%" class=" pa-1" align="center" padding="0px">
                            <table style="width: 100%" class="mb-1">
                                <tr @click="insAmmonizionePenaltyOK('S')">
                                    <td width="10%" class="pa-3 grey darken-2 white--text" align="center"   >
                                        <strong >S</strong>
                                    </td>
                                    <td width="90%" class="pa-3 grey lighten-2 black--text" align="left"  >
                                        <strong >COMPORTAMENTO SWIM </strong>
                                    </td>
                                </tr>
                                <tr @click="insAmmonizionePenaltyOK('B')">
                                    <td width="10%" class="pa-3 grey darken-2 white--text" align="center"   >
                                        <strong >B</strong>
                                    </td>
                                    <td width="90%" class="pa-3 grey lighten-2 black--text" align="left"  >
                                        <strong >COMPORTAMENTO BIKE </strong>
                                    </td>
                                </tr>
                                <tr @click="insAmmonizionePenaltyOK('R')">
                                    <td width="10%" class="pa-3 grey darken-2 white--text" align="center"   >
                                        <strong >R</strong>
                                    </td>
                                    <td width="90%" class="pa-3 grey lighten-2 black--text" align="left"  >
                                        <strong >COMPORTAMENTO RUN </strong>
                                    </td>
                                </tr>
                                <tr @click="insAmmonizionePenaltyOK('E')">
                                    <td width="10%" class="pa-3 grey darken-2 white--text" align="center"   >
                                        <strong >E</strong>
                                    </td>
                                    <td width="90%" class="pa-3 grey lighten-2 black--text" align="left"  >
                                        <strong >MATERIALE FUORI POSTO</strong>
                                    </td>
                                </tr>
                              
                                <tr @click="insAmmonizionePenaltyOK('M')">
                                    <td width="10%" class="pa-3 grey darken-2 white--text" align="center"   >
                                        <strong >M</strong>
                                    </td>
                                    <td width="90%" class="pa-3 grey lighten-2 black--text" align="left"  >
                                        <strong >MOUNT LINE</strong>
                                    </td>
                                </tr>
                                <tr @click="insAmmonizionePenaltyOK('D')">
                                    <td width="10%" class="pa-3 grey darken-2 white--text" align="center"   >
                                        <strong >D</strong>
                                    </td>
                                    <td width="90%" class="pa-3 grey lighten-2 black--text" align="left"  >
                                        <strong >DISMOUNT LINE</strong>
                                    </td>
                                </tr>
                                <tr @click="insAmmonizionePenaltyOK('V')">
                                    <td width="10%" class="pa-3 grey darken-2 white--text" align="center"   >
                                        <strong >V</strong>
                                    </td>
                                    <td width="90%" class="pa-3 grey lighten-2 black--text" align="left"  >
                                        <strong >ALTRE VIOLAZIONI</strong>
                                    </td>
                                </tr>
                            </table>
                            
                        </td>
                    </tr>
                    <!--tr>
                        <td width="100%" class=" pa-0" align="left">
                            Ultimi: {{ lastBib }}
                        </td>
                    </tr-->


                </table>
                <v-btn round class="black  white--text" @click="showViolations = false">ANNULLA</v-btn>
            </v-layout>
        </v-dialog>



        <v-dialog light persistent v-model="showSelected" class="cardUp">
            <v-layout align-center column justify-center class="cardStats pa-1 white black--text" style="height:100%">
                <table v-if="selectedItem != undefined" style="width: 100%">
                    <tr :class="'cardStats pa-1 black--text ' + selectedItem.tipo">
                        <td width="100%" class="pa-1" align="center">
                            <strong>{{ selectedItem.descrizione }}</strong>
                        </td>
                    </tr>
                    <tr>
                        <td width="100%" class="pa-1 black--text white"
                            style="border:2px solid red; height: 50px !important; border-radius: 5px;" align="center">
                            <strong class="display-2">{{ selectedItem.destinatorio }}</strong>
                        </td>
                    </tr>

                    <tr>
                        <td width="100%" class="pa-1 black--text white" align="left">
                            Nota: {{ selectedItem.note }}
                        </td>
                    </tr>
                    <tr>
                        <td width="100%" class=" pa-0" align="center" padding="0px">
                            <table style="width: 100%" class="mb-1">
                                <tr>
                                    <td width="100%" class="pa-3 grey lighten-2 black--text" align="center"
                                        @click="notaEvento(selectedItem)">
                                        <strong>AGGIUNGI NOTA</strong>
                                    </td>
                                </tr>
                                <tr v-if="selectedItem.tipo != 'foto'">
                                    <td align="center" class="" >
                                    </td>

                                </tr>
                                <tr v-if="selectedItem.tipo != 'foto'">
                                    <td align="center" class="teal lighten-4" >
                                   ALLEGA FOTO
                                    </td>

                                </tr>
                                <tr v-if="selectedItem.tipo != 'foto'">
                                    <td align="center" class="teal lighten-4" >
                                    <input type="file" accept="image/*" @change="onFileChange" />
                                    </td>

                                </tr>
                                <tr v-if="selectedItem.tipo != 'foto'">
                                    <td align="center" class="" >
                                    </td>

                                </tr>
                                <tr>
                                    <td width="100%" class="pa-3 grey lighten-2 red--text" align="center"
                                        @click="cancEvento(selectedItem)">
                                        <strong>CANCELLA RIGA</strong>
                                    </td>
                                </tr>

                                <tr>
                                    <td width="100%" class="pa-1 black--text white" align="left">
                                        Giudice: {{ selectedItem.originatore }} - {{ selectedItem.orario }}
                                    </td>
                                </tr>
                                <tr>
                                    <td width="100%" class="pa-3" align="center">
                                        <v-btn round class="black  white--text" @click="showSelected = false">CHIUDI</v-btn>
                                    </td>

                                </tr>

                            </table>
                        </td>
                    </tr>
                </table>
            </v-layout>
        </v-dialog>


        <v-dialog light persistent v-model="showSelectedPenalty" class="cardUp">
            <v-layout align-center column justify-center class="cardStats pa-1 white black--text" style="height:100%">
                <table v-if="selectedItem != undefined" style="width: 100%">
                    <tr :class="'cardStats pa-1 black--text ' + selectedItem.tipo">
                        <td width="100%" class="pa-1" align="center">
                            <strong>{{ selectedItem.descrizione }}</strong>
                        </td>
                    </tr>
                    <tr>
                        <td width="100%" class="pa-1 black--text white"
                            style="border:2px solid red; height: 50px !important; border-radius: 5px;" align="center">
                            <strong class="display-2">{{ selectedItem.destinatorio }}</strong>
                        </td>
                    </tr>
                    <tr>
                        <td width="100%" class=" pa-1" align="center" padding="0px">
                            <table style="width: 100%" class="mb-1">
                                <tr v-if="selectedItem.stato.startsWith('PENALTY_')">
                                    <td width="100%" class="pa-3 green lighten-2 black--text" align="center"
                                        @click="avviaTimerPitStop(selectedItem)">
                                        <strong>INIZIA PENALTY</strong><br>


                                    </td>
                                </tr>
                                <tr v-if="selectedItem.stato.startsWith('START_PENALTY')">
                                    <td width="100%" class="pa-3 red lighten-2 black--text" align="center"
                                        @click="finePitStop(selectedItem)">
                                        <strong>FINE PENALTY</strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="100%" class="pa-3 white" align="center">
                                        <strong></strong>
                                    </td>

                                </tr>
                                <tr v-if="selectedItem.tipo != 'foto'">
                                    <td align="center" class="teal lighten-4" >
                                   ALLEGA FOTO
                                    </td>

                                </tr>
                                <tr v-if="selectedItem.tipo != 'foto'">
                                    <td align="center" class="teal lighten-4" >
                                    <input type="file" accept="image/*" @change="onFileChange" />
                                    </td>

                                </tr>
                                <tr v-if="selectedItem.tipo != 'foto'">
                                    <td align="center" class="" >
                                    </td>

                                </tr>
                                <tr>
                                    <td width="100%" class="pa-3" align="center">
                                        <v-btn round class="black  white--text"
                                            @click="showSelectedPenalty = false">CHIUDI</v-btn>
                                    </td>

                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            </v-layout>
        </v-dialog>

       


        <v-toolbar app color="blue darken-2" dark>
            <v-toolbar-title data-cy="titleBtn">
                <img class="menuLogo ml-0 mt-2" src="../assets/loghi/fitriWhite.png" style="height: 40px" />
            </v-toolbar-title>
            <v-spacer></v-spacer>

            <span class="ml-4" v-if="currentPage == 'storico'">
                <v-icon @click="forceReload()">refresh</v-icon>
            </span>
            <span class="ml-4" v-if="currentPage !== 'event' && currentPage !== 'races' && currentPage !== 'login'">
                <v-icon @click="gotoHome()">apps</v-icon>
            </span>

            <span class="ml-4" v-if="currentPage == 'races'">
                <v-icon @click="showImpostazioni = !showImpostazioni">settings</v-icon>
            </span>

            <span v-if="currentPage == 'event' || currentPage == 'races'" class="white--text ml-5"
                style="float:right"><strong class="ml-2">{{ user }}</strong><span v-if="isAdmin()"> (admin)</span></span>




            <!--span class="mr-4" v-if="currentPage == 'event'">
                <v-icon @click="gotoRaces()">home</v-icon>
            </span-->


            <!--v-icon
                    v-if="filterPreferiti"
                    class="mr-4 yellow--text"
                    @click="togglePreferiti()"
                    >star</v-icon
                >
                <v-icon v-else class="mr-4 yellow--text" @click="togglePreferiti()"
                    >star_border</v-icon
                -->
            <!--span>
                <v-icon v-if="!compatta" @click="compatta = !compatta">compress</v-icon>
                <v-icon v-else @click="compatta = !compatta">expand</v-icon>
            </span-->
            <!--span>
                <v-icon @click="refreshData()">refresh</v-icon>
            </span-->
            <v-layout align-start row wrap justify-center class="grey darken-3 p-2  v-toolbar--fixed"
                style="width:100%; margin-top:55px">
                <span class="white--text"><strong>{{ raceTitle }}</strong> - {{ selectedRace }}</span>

            </v-layout>


        </v-toolbar>

        <v-progress-linear v-if="showProgressBar" background-color="blue darken-2" color="blue darken-4"
            class="mt-0 p-0 v-toolbar--fixed" v-model="value" :buffer-value="bufferValue"></v-progress-linear>
        <v-layout align-start row wrap justify-center class="mt-2">
            <v-flex flex xs12 sm12 md12 lg12>
                <v-layout align-start row wrap justify-center class="mt-3 white--text blue darken-4">

                </v-layout>
            </v-flex>
        </v-layout>
        <v-layout v-if="currentPage == 'login' && configOK" align-start row wrap justify-center class="mt-2">

            <v-flex flex xs12 sm12 md12 lg12>
                <v-layout align-start row wrap justify-center class="mt-2">
                    <v-flex flex xs12 sm12 md12 lg12>

                        <table style="width: 100%">
                            <tr>
                                <td width="100%" class="pa-1 white--text" align="center">
                                    <strong>ACCESSO APP GIUDICE</strong>
                                </td>
                            </tr>
                            <tr>
                                <td width="100%" class="pa-4 blue darken-2 white--text" align="center">
                                    <v-text-field color="white" class="white--text" v-model="loginField"
                                        label="Inserisci cognome e nome "></v-text-field>
                                </td>
                            </tr>
                            <tr>
                                <td width="100%" class="pa-3 white--text" align="center">
                                    <v-btn round class="green white--text" @click="accedi()">ACCEDI</v-btn>
                                </td>
                            </tr>
                        </table>

                    </v-flex>

                </v-layout>

            </v-flex>
        </v-layout>
        <v-layout v-if="currentPage == 'storico' && configOK" align-start row wrap justify-center class="mt-2">
            <v-flex flex xs12 sm12 md12 lg12>
                <table width="100%" class="">
                    <tr>
                        <td width="100%" align="center" colspan="3" style="color:white; height: 40px"><strong>STORICO
                                EVENTI</strong></td>
                    </tr>
                </table>
            </v-flex>
            <v-flex flex xs12 sm12 md12 lg12>
                <v-layout align-start row wrap justify-center class="mt-1">
                    <v-flex flex xs12 sm12 md12 lg12>
                        <v-data-table :items="itemsF" hide-actions hide-headers class="elevation-1 mb-5 mt-4"
                            style="width: 100%">
                            <template slot="items" slot-scope="props">
                                <tr style="height:1px">
                                    <td style="height:1px"></td>
                                </tr>
                                <tr style="padding: 1px !important;" class="black white--text">
                                    <td width="10%" align="center" :class="getColor(props.item)">
                                        <strong> {{ props.item.destinatorio }}</strong><span class="ml-1"
                                            v-if="props.item.note !== null && props.item.note !== ''">*</span>
                                    </td>
                                    <td width="70%" align="left">
                                        <strong> {{ props.item.descrizione }}
                                        </strong><br><small class="grey--text">
                                            {{ props.item.originatore }} - {{ props.item.orario }}
                                        </small>

                                    </td>
                                    <td width="20%" align="right">
                                        <span class="mt-1 p-0" style="float: right; color: white; margin-right: 10px;">
                                            <v-icon class="white--text pa-0"
                                                @click="selezionaEvento(props.item)">list</v-icon>
                                        </span>
                                    </td>
                                </tr>

                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <v-layout v-if="currentPage == 'event' && configOK" align-start row wrap justify-center class="mt-2">

            <v-flex flex xs12 sm12 md12 lg12>
                <v-layout align-start row wrap justify-center class="mt-2">
                    <v-flex flex xs12 sm12 md12 lg12>
                        <table width="100%" class="mt-1" style="border-collapse: separate; border-spacing: 10px;">
                            <tr style="height: 70px;">

                                <td width="50%" align="center" class="white black--text" @click="showAssenti()">
                                    <strong>REGISTRA<br>ASSENTI</strong>
                                </td>
                                <td width="50%" align="center" class="grey black--text" @click="showRitirati()">
                                    <strong>REGISTRA<br>RITIRATI</strong>
                                </td>
                            </tr>
                            <tr style="height: 70px;">
                                <td width="50%" align="center" class="black white--text" @click="showCartellini()">
                                    <table width="100%" class="black pa-0 ma-0">
                                        <tr style="height: 25px;">
                                            <td class="yellow black--text" style="text-align: center;">
                                                <strong>AMMONIZIONI</strong></td>
                                        </tr>
                                        <tr style="height: 25px;">
                                            <td class="red  white--text" style="text-align: center;">
                                                <strong>ESPULSIONI</strong></td>
                                        </tr>
                                        <tr style="height: 20px;">
                                            <td class="blue darken-4 white--text" style="text-align: center;">
                                                <strong>PENALTY</strong></td>
                                        </tr>
                                    </table>

                                </td>
                                <td width="50%" align="center" class="blue darken-4 white--text" @click="showPenalty()">
                                    <strong>PENALTY<br>BOX</strong>
                                </td>
                            </tr>
                            <tr style="height: 70px; ">
                                <td width="50%" align="center" class="blue lighten-2 black--text" @click="gotoRaces()">
                                    <strong>CAMBIA<br>GARA-DIVISIONE</strong>
                                </td>
                                <td width="50%" align="center" class="teal lighten-4 black--text" @click="showFoto()">
                                    <strong>GESTIONE<br>FOTO</strong>
                                </td>
                               
                            </tr>
                            <tr style="height: 70px;">

                                <td width="50%" align="center" class="grey darken-3 white--text" @click="showStorico()">
                                    <strong>STORICO<br>EVENTI</strong>
                                </td>
                                <td width="50%" align="center" class="teal darken-4 white--text" @click="showRiepilogo()">
                                    <strong>RIEPILOGO
                                    </strong>
                                </td>
                            </tr>
                            <tr  style="height: 40px;">
                                <td colspan="2" align="center" class="grey darken-4 white--text" @click="showMore = !showMore" style="">
                                    <strong><span v-if="showMore">NASCONDI</span><span v-else>MOSTRA</span><br>ALTRE FUNZIONI</strong>
                                </td>
                            </tr>

                            <tr v-if="showMore" style="height: 70px;">
                                <td width="50%" align="center" class="orange black--text" @click="regIscritti()">
                                    <strong>REGISTRA<br>ISCRITTI</strong>
                                </td>
                                <td width="50%" align="center" class="green darken-2 white--text" @click="showPartenze()">
                                    <strong>REGISTRA<br>PARTENZE</strong>
                                </td>
                            </tr>
                            <tr v-if="showMore" style="height: 70px;">
                                <td width="50%" align="center" class="blue darken-2 white--text" @click="cambiaNome()">
                                    <strong>CAMBIA<br>NOME</strong>
                                </td>
                                <td  width="50%" align="center" class="pink white--text" @click="showContatti()">
                                    <strong>CONTATTI<br>TELEFONICI</strong>
                                </td>

                               
                              
                            </tr>
                          

                        </table>
                    </v-flex>

                </v-layout>

            </v-flex>


            <v-flex flex xs12 sm12 md12 lg12>
                <v-layout v-if="!configOK" align-start row wrap justify-center class="mt-4 ">
                    <v-flex flex xs12 sm12 md12 lg12 class="mb-5">
                        <v-layout class="display-1 justify-center">EVENTO NON CONFIGURATO</v-layout>
                    </v-flex>
                </v-layout>

            </v-flex>



        </v-layout>
        <v-layout v-if="currentPage == 'cartellini' && configOK" align-start row wrap justify-center class="mt-2">
            <v-flex flex xs12 sm12 md12 lg12>
                <v-layout align-start row wrap justify-center class="mt-2">
                    <v-flex flex xs12 sm12 md12 lg12>
                        <table width="100%" class="mt-1">
                            <tr>
                                <td width="100%" align="center" colspan="3" style="color:white; height: 30px"><strong>SCEGLI
                                        IL CARTELLINO</strong></td>
                            </tr>
                            <tr>
                                <td width="33%" align="center" style="background-color:red; height: 120px !important"
                                    @click="ins('red')">
                                </td>
                                <td width="33%" align="center" style="background-color:yellow; height: 120px !important"
                                    @click="ins('yellow')">
                                </td>
                                <td width="33%" align="center" style="background-color:blue; height: 120px !important" class="white--text"
                                    @click="ins('blue')">{{ selectedTimeMax }} sec
                                </td>

                            </tr>

                        </table>
                    </v-flex>
                </v-layout>
            </v-flex>

            <v-flex flex xs12 sm12 md12 lg12>
                <v-layout align-start row wrap justify-center class="mt-1">
                    <v-flex flex xs12 sm12 md12 lg12>
                        <v-data-table :items="itemsCartellini" hide-actions hide-headers class="elevation-1 mb-5 mt-4"
                            style="width: 100%">
                            <template slot="items" slot-scope="props">
                                <tr style="height:1px">
                                    <td style="height:1px"></td>
                                </tr>
                                <tr style="padding: 1px !important;" class="black white--text">
                                    <td width="10%" align="center" :class="getColor(props.item)">
                                        <strong> {{ props.item.destinatorio }}</strong><span class="ml-1"
                                            v-if="props.item.note !== null && props.item.note !== ''">*</span>
                                    </td>
                                    <td width="70%" align="left">
                                        <strong> {{ props.item.descrizione }}
                                        </strong><br><small class="grey--text">
                                            {{ props.item.originatore }} - {{ props.item.orario }}
                                        </small>

                                    </td>
                                    <td width="20%" align="right">
                                        <span class="mt-1 p-0" style="float: right; color: white; margin-right: 10px;">
                                            <v-icon class="white--text pa-0"
                                                @click="selezionaEvento(props.item)">list</v-icon>
                                        </span>
                                    </td>
                                </tr>

                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <v-layout v-if="currentPage == 'races' && configOK" align-start row wrap justify-center class="pa-2">

            <v-flex flex xs12 sm12 md12 lg12 class="mt-2">
                <table width="100%" class="">
                    <tr>
                        <td width="100%" align="center" colspan="3" style="color:white; height: 40px"><strong>SELEZIONA
                                LA DIVISIONE</strong></td>
                    </tr>
                </table>
            </v-flex>
            <v-flex flex xs12 sm12 md12 lg12>
                <v-data-table :items="raceList" hide-actions hide-headers class="elevation-1 mb-5 mt-4 black"
                    style="width: 100%">
                    <template slot="items" slot-scope="props">

                        <tr class="pa-2"
                            style="height: 50px; border: 1px solid red; border-collapse: separate; border-spacing: 15px;">
                            <td class="black pa-0 white--text display-1"
                                style="height: 40px; border-collapse: separate; border-spacing: 10px; "
                                @click="selezionaGara(props.item)">
                                <span class="ml-3">{{ props.item }}</span>
                            </td>
                        </tr>

                    </template>
                </v-data-table>
            </v-flex>

            <v-flex flex xs12 sm12 md12 lg12 class="mt-1" v-if="showImpostazioni">
                <table width="100%" class="">
                    <tr style="height: 60px">
                        <td width="50%" align="center" class="white black--text" @click="creaGara()">
                            <strong>CREA NUOVA<br>DIVISIONE</strong>
                        </td>

                    </tr>
                </table>

            </v-flex>

            <v-flex flex xs12 sm12 md12 lg12 class="mt-2" v-if="showImpostazioni">
                <table width="100%" >
                    <tr style="height: 60px" class="pa-2 ma-2">
                        <td width="50%" align="center" class="white--text" >
                            <strong>IMPOSTA TIPOLOGIA di GARA</strong><br>Attuale: {{ selectedTime  }} - {{ selectedTimeMax }}
                        </td>
                    </tr>
                    <tr style="height: 60px" >
                        <td width="100%" align="center" :class=" 'pa-2 ma-2 ' + (selectedTime == 10 ? 'orange black--text' : 'grey black--text')" @click="impostaTipoGara('SPRINT')">
                            <strong>SPRINT o inferiori</strong>
                        </td>
                    </tr>
                    <tr style="height: 60px" >
                        <td width="100%" align="center" :class=" 'pa-2 ma-2 ' + (selectedTime == 15 ? 'orange black--text' : 'grey black--text')"  @click="impostaTipoGara('OLIMPICO')">
                            <strong>OLIMPICO</strong>
                        </td>
                    </tr>
                    <tr style="height: 60px" >
                        <td width="100%" align="center" :class=" 'pa-2 ma-2 ' + (selectedTime == 30 ? 'orange black--text' : 'grey black--text')"  @click="impostaTipoGara('MEDIO')">
                            <strong>MEDIO</strong>
                        </td>
                    </tr>
                    <tr style="height: 60px" >
                        <td width="100%" align="center" :class=" 'pa-2 ma-2 ' + (selectedTime == 60 ? 'orange black--text' : 'grey black--text')"  @click="impostaTipoGara('LUNGO')">
                            <strong>LUNGO</strong>
                        </td>
                    </tr>
                
                </table>
                
            </v-flex>

        </v-layout>

        <v-layout v-if="currentPage == 'penalty' && configOK" align-start row wrap justify-center class="pa-2">
            <v-flex v-if="false" flex xs12 sm12 md12 lg12>
                <v-layout align-start row wrap justify-center class="">
                    <v-flex flex xs12 sm12 md12 lg12>
                        <table width="100%" class="">
                            <tr>
                                <td align="center" style="background-color:blue; height: 90px !important" class="white--text"
                                    @click="ins('blue')"><strong >INSERISCI PENALTY</strong><br>{{ selectedTimeMax }} sec.
                                </td>

                            </tr>
                        </table>
                    </v-flex>
                </v-layout>
            </v-flex>


            <v-flex flex xs12 sm12 md12 lg12 class="mt-2">
                <table width="100%" class="">
                    <tr>
                        <td width="100%" align="center" colspan="3" style="color:white; height: 40px"><strong>ATLETI DA
                                FERMARE</strong></td>
                    </tr>
                </table>
            </v-flex>

            <v-flex flex xs12 sm12 md12 lg12>
                <v-data-table :items="itemsBLU" hide-actions hide-headers class="elevation-1 mb-5 mt-4" style="width: 100%">
                    <template slot="items" slot-scope="props">
                        <tr style="height:1px">
                            <td style="height:1px"></td>
                        </tr>
                        <tr style="padding: 1px !important;" class="black white--text">
                            <td width="1%" align="center" class="red white--text no-wrap">
                                <small>
                                    <v-icon class="white--text pa-0">front_hand</v-icon><br> {{ props.item.seconds }} sec.
                                </small>
                            </td>
                            <td width="10%" align="center" :class="getColor(props.item)">
                                <strong> {{ props.item.destinatorio }}</strong>
                            </td>
                            <td width="70%" align="left">
                                <span> {{ props.item.orario }} - {{ props.item.descrizione }}
                                </span><br><small>
                                    Giudice: {{ props.item.originatore }}
                                </small>

                            </td>
                            <td width="20%" align="right">
                                <span class="mt-1 p-0" style="float: right; color: white; margin-right: 10px;">
                                    <v-icon class="white--text pa-0" @click="selezionaEventoBlu(props.item)">list</v-icon>
                                </span>
                            </td>
                        </tr>

                    </template>
                </v-data-table>
            </v-flex>

            <v-flex flex xs12 sm12 md12 lg12 class="mt-2">
                <table width="100%" class="">
                    <tr>
                        <td width="100%" align="center" colspan="3" style="color:white; height: 40px"><strong>PENALTY IN
                                CORSO</strong></td>
                    </tr>
                </table>
            </v-flex>

            <v-flex flex xs12 sm12 md12 lg12>
                <v-data-table :items="itemsBLUExecuting" hide-actions hide-headers class="elevation-1 mb-5 mt-4"
                    style="width: 100%">
                    <template slot="items" slot-scope="props">
                        <tr style="height:1px">
                            <td style="height:1px"></td>
                        </tr>
                        <tr style="padding: 1px !important;" class="black white--text">
                            <td width="1%" align="center" :class="props.item.end <= 0
                                ? 'green lighten-3 black--text no-wrap'
                                : 'orange lighten-3 black--text no-wrap'">
                                <strong v-if="props.item.end > 0">
                                    <v-icon class="black--text pa-0">hourglass_top</v-icon>
                                    <br><span>{{ props.item.end }} sec.</span>
                                </strong>
                                <v-icon v-else class="black--text pa-0">thumb_up</v-icon>
                            </td>
                            <td width="9%" align="center" :class="getColor(props.item)">
                                <strong> {{ props.item.destinatorio }}</strong>
                            </td>
                            <td width="70%" align="left">

                                <span> {{ props.item.orario }}<br> Fine: {{ props.item.note }}
                                </span><br><small>
                                    Giudice: {{ props.item.originatore }}
                                </small>

                            </td>
                            <td width="20%" align="right">
                                <span class="mt-1 p-0" style="float: right; color: white; margin-right: 10px;">
                                    <v-icon class="white--text pa-0" @click="selezionaEventoBlu(props.item)">list</v-icon>
                                </span>
                            </td>
                        </tr>


                    </template>
                </v-data-table>
            </v-flex>

            <v-flex flex xs12 sm12 md12 lg12 class="mt-2">
                <table width="100%" class="">
                    <tr>
                        <td width="100%" align="center" colspan="3" style="color:white; height: 40px"><strong>PENALTY
                                TERMINATI</strong></td>
                    </tr>
                </table>
            </v-flex>

            <v-flex flex xs12 sm12 md12 lg12>
                <v-data-table :items="itemsBLUExecuted" hide-actions hide-headers class="elevation-1 mb-5 mt-4"
                    style="width: 100%">
                    <template slot="items" slot-scope="props">
                        <tr style="height:1px">
                            <td style="height:1px"></td>
                        </tr>
                        <tr style="padding: 1px !important;" class="black white--text">
                            <td width="1%" align="center" class="green lighten-3 black--text">
                                <small> <v-icon class="black--text pa-0">timer</v-icon></small>
                            </td>
                            <td width="9%" align="center" :class="getColor(props.item)">
                                <strong> {{ props.item.destinatorio }}</strong>
                            </td>
                            <td width="70%" align="left">
                                <span> {{ props.item.orario }} - {{ props.item.descrizione }}
                                </span><br><small>
                                    Giudice: {{ props.item.originatore }}
                                </small>

                            </td>
                            <td width="20%" align="right">
                                <span class="mt-1 p-0" style="float: right; color: white; margin-right: 10px;">
                                    <!--v-icon class="white--text pa-0"
                                                @click="selezionaEventoBlu(props.item)">list</v-icon -->
                                </span>
                            </td>
                        </tr>

                    </template>
                </v-data-table>
            </v-flex>

        </v-layout>
        <v-layout v-if="currentPage == 'assenti' && configOK" align-start row wrap justify-center class="mt-2">
            <v-flex flex xs12 sm12 md12 lg12>
                <v-layout align-start row wrap justify-center class="">
                    <v-flex flex xs12 sm12 md12 lg12>
                        <table width="100%" class="">

                            <tr>
                                <td align="center" style="background-color:white; height: 90px !important"
                                    @click="ins('white')"><strong class="">INSERISCI ASSENTE</strong>
                                </td>

                            </tr>

                            <tr>
                                <td width="100%" align="right" class="white--text">Numero assenti: <span class="red pa-1">{{
                                    itemsAssenti.length }}</span></td>
                            </tr>

                        </table>
                    </v-flex>
                </v-layout>
            </v-flex>

            <v-flex flex xs12 sm12 md12 lg12>
                <v-layout align-start row wrap justify-center class="">
                    <v-flex flex xs12 sm12 md12 lg12>
                        <v-data-table :items="itemsAssenti" hide-actions hide-headers class="elevation-1 mb-5 mt-1"
                            style="width: 100%">
                            <template slot="items" slot-scope="props">
                                <tr style="height:1px">
                                    <td style="height:1px"></td>
                                </tr>
                                <tr style="padding: 1px !important;" class="black white--text">
                                    <td width="10%" align="center" :class="getColor(props.item)">
                                        <strong> {{ props.item.destinatorio }}</strong><span class="ml-1"
                                            v-if="props.item.note !== null && props.item.note !== ''">*</span>
                                    </td>
                                    <td width="70%" align="left">
                                        <strong> {{ props.item.descrizione }}
                                        </strong><br><small class="grey--text">
                                            {{ props.item.originatore }} - {{ props.item.orario }}
                                        </small>

                                    </td>
                                    <td width="20%" align="right">
                                        <span class="mt-1 p-0" style="float: right; color: white; margin-right: 10px;">
                                            <v-icon class="white--text pa-0"
                                                @click="selezionaEvento(props.item)">list</v-icon>
                                        </span>
                                    </td>
                                </tr>

                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <v-layout v-if="currentPage == 'ritirati' && configOK" align-start row wrap justify-center class="mt-2">
            <v-flex flex xs12 sm12 md12 lg12>
                <v-layout align-start row wrap justify-center class="">
                    <v-flex flex xs12 sm12 md12 lg12>
                        <table width="100%" class="">

                            <tr>
                                <td align="center" style="background-color:lightgrey; height: 90px !important"
                                    @click="ins('grey')"><strong class="">INSERISCI RITIRATO</strong>
                                </td>

                            </tr>

                            <tr>
                                <td width="100%" align="right" class="white--text">Numero ritirati: <span
                                        class="red pa-1">{{ itemsRitirati.length }}</span></td>
                            </tr>

                        </table>
                    </v-flex>
                </v-layout>
            </v-flex>

            <v-flex flex xs12 sm12 md12 lg12>
                <v-layout align-start row wrap justify-center class="">
                    <v-flex flex xs12 sm12 md12 lg12>
                        <v-data-table :items="itemsRitirati" hide-actions hide-headers class="elevation-1 mb-5 mt-1"
                            style="width: 100%">
                            <template slot="items" slot-scope="props">
                                <tr style="height:1px">
                                    <td style="height:1px"></td>
                                </tr>
                                <tr style="padding: 1px !important;" class="black white--text">
                                    <td width="10%" align="center" :class="getColor(props.item)">
                                        <strong> {{ props.item.destinatorio }}</strong><span class="ml-1"
                                            v-if="props.item.note !== null && props.item.note !== ''">*</span>
                                    </td>
                                    <td width="70%" align="left">
                                        <strong> {{ props.item.descrizione }}
                                        </strong><br><small class="grey--text">
                                            {{ props.item.originatore }} - {{ props.item.orario }}
                                        </small>

                                    </td>
                                    <td width="20%" align="right">
                                        <span class="mt-1 p-0" style="float: right; color: white; margin-right: 10px;">
                                            <v-icon class="white--text pa-0"
                                                @click="selezionaEvento(props.item)">list</v-icon>
                                        </span>
                                    </td>
                                </tr>

                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <v-layout v-if="currentPage == 'contatti' && configOK" align-start row wrap justify-center class="mt-2">
            <v-flex flex xs12 sm12 md12 lg12>
                <v-layout align-start row wrap justify-center class="">
                    <v-flex flex xs12 sm12 md12 lg12>
                        <table width="100%" class="">

                            <tr>
                                <td align="center" style="height: 90px !important" class="pink white--text"
                                    @click="insContatto()"><strong class="">INSERISCI CONTATTO</strong>
                                </td>

                            </tr>
                        </table>
                    </v-flex>
                </v-layout>
            </v-flex>

            <v-flex flex xs12 sm12 md12 lg12>
                <v-layout align-start row wrap justify-center class="">
                    <v-flex flex xs12 sm12 md12 lg12>
                        <v-data-table :items="itemsContatti" hide-actions hide-headers class="elevation-1 mb-5 mt-1"
                            style="width: 100%">
                            <template slot="items" slot-scope="props">
                                
                                <tr style="padding: 1px !important;" class="black white--text">
                                    <td width="10%" align="center" class="pink white--text">
                                     
                                    </td>
                                    <td width="70%" align="left">
                                        <strong> {{ props.item.descrizione }}
                                        </strong><br><small class="grey--text">
                                            {{ props.item.originatore }} - {{ props.item.orario }}
                                        </small>

                                    </td>
                                    <td width="20%" align="right">
                                        <span class="mt-1 p-0" style="float: right; color: white; margin-right: 10px;">
                                            <v-icon class="white--text pa-0"
                                                @click="selezionaEvento(props.item)">list</v-icon>
                                        </span>
                                    </td>
                                </tr>

                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>


        <v-layout v-if="currentPage == 'foto' && configOK" align-start row wrap justify-center class="mt-2">
            <v-flex flex xs12 sm12 md12 lg12>
                <v-layout align-start row wrap justify-center class="">
                    <v-flex flex xs12 sm12 md12 lg12>
                        <table width="100%" class="">

                            <tr>
                                <td align="center" class="teal lighten-4 " 
                                   ><strong class="">ALLEGA FOTO</strong>
                                </td>

                            </tr>

                            <tr  style="height: 70px;">
                                <td colspan=2   align="center" class="teal lighten-4" >
                                    <input type="file" accept="image/*" @change="onGenericFileChange" />
                                </td>
                              
                            </tr>

                        </table>
                    </v-flex>
                </v-layout>
            </v-flex>

            <v-flex flex xs12 sm12 md12 lg12>
                <v-layout align-start row wrap justify-center class="">
                    <v-flex flex xs12 sm12 md12 lg12>
                        <v-data-table :items="itemsFoto" hide-actions hide-headers class="elevation-1 mb-5 mt-1"
                            style="width: 100%">
                            <template slot="items" slot-scope="props">
                                <tr style="height:1px">
                                    <td style="height:1px"></td>
                                </tr>
                                <tr style="padding: 1px !important;" class="black white--text">
                                    <td width="10%" align="center" :class="getColor(props.item)">
                                        <strong> {{ props.item.destinatorio }}</strong><span class="ml-1"
                                            v-if="props.item.note !== null && props.item.note !== ''">*</span>
                                    </td>
                                    <td width="70%" align="left">
                                        <strong> {{ props.item.descrizione }}
                                        </strong><br><small class="grey--text">
                                            {{ props.item.originatore }} - {{ props.item.orario }}
                                        </small>

                                    </td>
                                    <td width="20%" align="right">
                                        <span class="mt-1 p-0" style="float: right; color: white; margin-right: 10px;">
                                            <v-icon class="white--text pa-0"
                                                @click="selezionaEvento(props.item)">list</v-icon>
                                        </span>
                                    </td>
                                </tr>

                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>


        <v-layout v-if="currentPage == 'partenze' && configOK" align-start row wrap justify-center class="mt-2">
            <v-flex flex xs12 sm12 md12 lg12>
                <v-layout align-start row wrap justify-center class="">
                    <v-flex flex xs12 sm12 md12 lg12>
                        <table width="100%" class="">

                            <tr>
                                <td align="center" style="background-color:green; height: 90px !important"
                                    @click="partenza()"><strong class="white--text">REGISTRA PARTENZA</strong>
                                </td>

                            </tr>
                        </table>
                    </v-flex>
                </v-layout>
            </v-flex>

            <v-flex flex xs12 sm12 md12 lg12>
                <v-layout align-start row wrap justify-center class="">
                    <v-flex flex xs12 sm12 md12 lg12>
                        <v-data-table :items="itemsPartenze" hide-actions hide-headers class="elevation-1 mb-5 mt-1"
                            style="width: 100%">
                            <template slot="items" slot-scope="props">
                                <tr style="height:1px">
                                    <td style="height:1px"></td>
                                </tr>
                                <tr style="padding: 1px !important;" class="black white--text">
                                    <td width="10%" align="center" :class="getColor(props.item)">
                                        <strong> {{ props.item.destinatorio }}</strong><span class="ml-1"
                                            v-if="props.item.note !== null && props.item.note !== ''">*</span>
                                    </td>
                                    <td width="70%" align="left">
                                        <strong> {{ props.item.descrizione }}
                                        </strong><br><small class="grey--text">
                                            {{ props.item.originatore }} - {{ props.item.orario }}
                                        </small>

                                    </td>
                                    <td width="20%" align="right">
                                        <span class="mt-1 p-0" style="float: right; color: white; margin-right: 10px;">
                                            <v-icon class="white--text pa-0"
                                                @click="selezionaEvento(props.item)">list</v-icon>
                                        </span>
                                    </td>
                                </tr>

                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>

        <v-layout v-if="currentPage == 'riepilogo' && configOK" align-start row wrap justify-center class="mt-2">
            <v-flex flex xs12 sm12 md12 lg12>
                <table width="100%" class="blue darken-4 white--text">
                    <tr>
                        <td width="100%" align="center" colspan="3" style="color:white; height: 40px">
                            <strong>RIEPILOGO</strong></td>
                    </tr>
                </table>
            </v-flex>
            <v-flex flex xs12 sm12 md12 lg12>
                <v-layout align-start row wrap justify-center class="mt-1">
                    <v-flex flex xs12 sm12 md12 lg12>
                        <table style="width: 100%;" class="white--text">
                            <tr>
                                <td align="right" width="40%"><strong class="mr-2">ISCRITTI</strong></td>
                                <td align="center" width="60%" class="no-wrap green white--text"><strong> {{
                                    numeroTotaleIscritti
                                }}</strong>
                                </td>

                            </tr>
                            <tr>
                                <td align="right"><strong class="mr-2">ASSENTI</strong></td>
                                <td align="center" class="no-wrap white black--text "><strong> {{
                                    numeroTotaleAssenti
                                }}</strong>
                                </td>
                            </tr>
                            <tr>
                                <td align="right"><strong class="mr-2">PARTITI</strong></td>
                                <td align="center" class="no-wrap green darken-4 white--text "><strong> {{
                                    numeroTotalePartiti
                                }}</strong>
                                </td>
                            </tr>
                            <tr>
                                <td align="right"><strong class="mr-2">RITIRATI</strong></td>
                                <td align="center" class="no-wrap grey black--text "><strong> {{
                                    numeroTotaleRitirati
                                }}</strong>
                                </td>
                            </tr>
                            <tr>
                                <td align="right"><strong class="mr-2">AMMONITI</strong></td>
                                <td align="center" @click="filterState('ammoniti')"
                                    class="black--text ml-0 mt-1 yellow pa-1"><strong> {{
                                        numeroTotaleAmmoniti
                                    }}</strong>
                                </td>
                            </tr>
                            <tr>
                                <td align="right"><strong class="mr-2">SQUALIFICATI</strong></td>
                                <td align="center" @click="filterState('squalificati')" class="red darken-2 white--text">
                                    <strong> {{
                                        numeroTotaleSqualificati
                                    }}</strong>
                                </td>

                            </tr>

                        </table>

                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex flex xs12 sm12 md12 lg12 class="mt-4">
                    <v-layout align-start row wrap justify-center class="white--text">
                        <v-flex flex xs12 sm12 md12 lg12>
                            <table style="width: 100%;" class="white--text">
                                <tr>
                                    <td align="center" width="40%" class="grey black--text"><strong>RITIRATI</strong></td>
                                </tr>
                                <tr>
                                    <td class="pa-2">
                                        <v-layout align-start row wrap justify-start class="white--text">
                                            <strong v-for="item in itemsRitirati" class="grey darken-2 white--text pa-1 ma-1">{{ item.destinatorio }}</strong>
                                        </v-layout>
                                    </td>
                                </tr>
                                <tr>
                                    <td align="center" width="40%" class="yellow black--text wrap"><strong>AMMONITI</strong></td>
                                </tr>
                                <tr>
                                    <td class="pa-2">
                                        <v-layout align-start row wrap justify-start class="white--text">
                                            <strong v-for="item in itemsCartellini" v-if="item.tipo == 'yellow'" class="yellow black--text pa-1 ma-1">{{ item.destinatorio }}</strong>
                                        </v-layout>
                                    </td>
                                </tr>
                                <tr>
                                    <td align="center" width="40%" class="red white--text"><strong>SQUALIFICATI</strong></td>
                                </tr>
                                <tr>
                                    <td class="pa-2">
                                        <v-layout align-start row wrap justify-start class="white--text">
                                            <strong v-for="item in itemsCartellini" v-if="item.tipo == 'red'" class="red white--text pa-1 ma-1">{{ item.destinatorio }}</strong>
                                        </v-layout>
                                    </td>
                                </tr>
                                <tr>
                                    <td align="center" width="40%" class="blue darken-4 white--text"><strong>PENALTY</strong></td>
                                </tr>
                                <tr>
                                    <td class="pa-2">
                                        <v-layout align-start row wrap justify-start class="white--text">
                                            <strong v-for="item in itemsBLU" class="blue darken-4 white--text pa-1 ma-1">{{ item.destinatorio }}</strong>
                                        </v-layout>
                                    </td>
                                </tr>
                                <tr>
                                    <td align="center" width="40%" class="white black--text"><strong>ASSENTI</strong></td>
                                </tr>
                                <tr>
                                    <td class="pa-2">
                                        <v-layout align-start row wrap justify-start class="white--text">
                                            <strong v-for="item in itemsAssenti" class="white black--text pa-1 ma-1">{{ item.destinatorio }}</strong>
                                        </v-layout>
                                    </td>
                                </tr>
                            </table>
                        </v-flex>
                    </v-layout>
                </v-flex>
        </v-layout>


        <v-footer v-if="false && currentPage == 'event' || currentPage == 'storico'" fixed class="black white--text"
            style="height: 60px; padding: 0px">
            <v-layout align-start row wrap justify-center style="width:100%; ">
                <v-flex flex xs12 sm6 md6 lg6>
                    <table style="width: 100%;">
                        <tr>
                            <td align="center"><small>ISCR</small></td>
                            <td align="center"><small>ASS</small></td>
                            <td align="center"><small>PART</small></td>
                            <td align="center"><small>RIT</small></td>
                            <td align="center"><small>AMM</small></td>
                            <td align="center"><small>SQL</small></td>
                        </tr>
                        <tr>
                            <td width="15%" align="center" @click="filterState('iscritti')"
                                class="no-wrap green white--text"><strong> {{
                                    numeroTotaleIscritti
                                }}</strong>
                            </td>
                            <td width="15%" align="center" @click="filterState('assenti')"
                                class="no-wrap white black--text "><strong> {{
                                    numeroTotaleAssenti
                                }}</strong>
                            </td>
                            <td width="15%" align="center" @click="filterState('partiti')"
                                class="no-wrap green darken-4 white--text "><strong> {{
                                    numeroTotalePartiti
                                }}</strong>
                            </td>

                            <td width="15%" align="center" @click="filterState('ritirati')"
                                class="no-wrap grey black--text "><strong> {{
                                    numeroTotaleRitirati
                                }}</strong>
                            </td>
                            <td width="15%" align="center" @click="filterState('ammoniti')"
                                class="black--text ml-0 mt-1 yellow pa-1"><strong> {{
                                    numeroTotaleAmmoniti
                                }}</strong>
                            </td>
                            <td width="15%" align="center" @click="filterState('squalificati')"
                                class="red darken-2 white--text"><strong> {{
                                    numeroTotaleSqualificati
                                }}</strong>
                            </td>

                        </tr>
                    </table>
                </v-flex>

            </v-layout>
        </v-footer>
    </div>
</template>
    
<script>
import helper from '../helper';
import dayjs from 'dayjs';

const moment = require('moment');


export default {
    components: {
        //      live: LiveRanking,
    },
    name: 'Live',

    data() {
        return {
            items: [],
            itemsF: [],

            raceID: null,
            raceTitle: '',

            configEvento: {},
            

            myInterval: null,

        
            stats: false,
            loaded: false,
            dettaglio: false,
            currentItem: null,

            value: 0,
            bufferValue: 100,
            interval: 0,
            pause: false,
            indexTo: -1,

            local: undefined,

            color: 'red',
            baseColor: 'white:black',
            refreshData: 30000,
            refreshPage: 30000000,
            showProgressBar: true,

            

            raceTime: '00:00:00',

            addClockDialog: false,
            clockToAdd: "",
            rilevamentoSelected: undefined,
            rilevamentoSelectedTitle: undefined,
            rilevamentoSelectedType: undefined,

            configOK: false,
            mostraNazione: false,
            listaNazioni: [],

            showPinpad: false,

            pettoraleIns: '',

            penaltyType: '',

            raceList: [],
            selectedRace: '',


            numRilevati: 0,
            numeroTotaleIscritti: 0,
            numeroTotaleAssenti: 0,
            numeroTotaleRitirati: 0,
            numeroTotaleSqualificati: 0,
            numeroTotaleAmmoniti: 0,
            numeroTotalePartiti: 0,


            lastBib: '',

            showLogin: false,
            user: undefined,
            selectedItem: undefined,
            showSelected: false,
            showSelectedPenalty: false,

            itemsBLU: [],
            itemsBLUExecuted: [],
            itemsBLUExecuting: [],
            itemsCartellini: [],
            itemsAssenti: [],
            itemsRitirati: [],
            itemsPartenze: [],
            itemsContatti: [],
            itemsFoto: [],
            showPagePenalty: false,

            currentPage: undefined,

            loginField: '',

            selectedTime: 10,

            selectedTimeMax: 60,

            showImpostazioni: false,
            penaltyAmmonizione: 0,

            showMore: false,

            showViolations: false,

            violationType: "",

            image: undefined,

            file: undefined




        };
    },

    beforeCreate() { },

    created() { },

    beforeDestroy() {
        clearInterval(this.myInterval);
        clearInterval(this.myIntervalBar);
    },

    mounted() {
        //console.log(this.$route.params.sport);
        console.log(this.$route.params.raceID);
        this.raceID = this.$route.params.raceID;
        this.paramID = this.$route.params.id;


        this.token = this.$route.params.token;



        let pref = helper.ls.get('GIUDICIAPP');
        console.log('GIUDICIAPP:' + JSON.stringify(pref));
        if (pref == undefined || pref.user == undefined) {
            this.currentPage = 'login'
            /*this.user = prompt("Inserisci il tuo nome");
            if (this.user != undefined && this.user != '') {
                helper.ls.set('GIUDICIAPP', { user: this.user });
                pref = helper.ls.get('GIUDICIAPP');
            }*/
        } else {
            this.user = pref.user;
        }

        this.local = this.$route.params.local;

        clearInterval(this.myInterval);
        clearInterval(this.myIntervalBar);

        this.loadEvento();
    },

    methods: {

        cambiaNome(){
            this.currentPage = 'login'
        },

        convertBase64(file) {
            return new Promise((resolve, reject) => {
                const fileReader = new FileReader();
                fileReader.readAsDataURL(file);

                fileReader.onload = () => {
                    resolve(fileReader.result);
                };

                fileReader.onerror = (error) => {
                    reject(error);
                };
            });
        },

        onFileChange(e) {
            const file = e.target.files[0]

            this.convertBase64(file).then( base64 => {
                this.image = base64;
                this.pettoraleIns = this.selectedItem.destinatorio

                this.penaltyType = "foto";
                this.insEvento(this.penaltyType, file.name)

            });
        },


        onGenericFileChange(e) {
            const file = e.target.files[0]
           
            this.convertBase64(file).then( base64 => {
                this.image = base64;

                this.pettoraleIns = ""

                this.penaltyType = "foto";
                this.insEvento(this.penaltyType, file.name)

            });

        },


        ins(type) {
            this.lastBib = "";
            this.pettoraleIns = "";
            this.penaltyType = type;
            this.showPinpad = true;
        },

        insContatto(){
            const cont = prompt("Inserisci nome e numero telefonico\nes. Dottore:33536366363")
            if (cont != undefined && cont != '') {
                this.insEvento("contatto", cont)
            }
        },

        partenza() {
            this.pettoraleIns = dayjs(new Date()).format('HH:mm:ss');
            this.insEvento('green');
        },

       
        insEvento(_penaltyType, noteEvento) {
            if (this.selectedRace == undefined) return;

            this.lastEvento = _penaltyType;

            let _penalty = "";
            let _violationType = ""

            if (_penaltyType == 'blue') {
                _penalty = this.selectedTimeMax;
            } else if (_penaltyType == 'yellow' && this.penaltyAmmonizione > 0 ){
                _penalty = this.penaltyAmmonizione
                _violationType = this.violationType
            } 

            let data =
            {
                "eventoGara": {
                    "idManifestazione": this.selectedRace,
                    "idGara": this.raceID,
                    "tipo": _penaltyType,
                    "descrizione": "",
                    "originatore": this.user,
                    "stato": (_penalty == '' ? "INS" : "PENALTY_" + _penalty),
                    "destinatorio": this.pettoraleIns+ " "+_violationType,
                    "note": ""
                }

            }

            if (_penaltyType == 'white') {
                data.eventoGara.descrizione = "ASSENTE"
            } else if (_penaltyType == 'grey') {
                data.eventoGara.descrizione = "RITIRATO"
            } else if (_penaltyType == 'green') {
                data.eventoGara.descrizione = "PARTENZA";

            } else if (_penaltyType == 'red') {
                data.eventoGara.descrizione = "SQUALIFICATO"
            } else if (_penaltyType == 'yellow') {
                data.eventoGara.descrizione = "AMMONITO "
                if (_penalty != '') data.eventoGara.descrizione += " penalty " + _penalty + " sec."
            } else if (_penaltyType == 'blue') {
                data.eventoGara.descrizione = "PENALTY"
                if (_penalty != '') data.eventoGara.descrizione += " " + _penalty + " sec."

            } else if (_penaltyType == 'regiscritti') {
                data.eventoGara.descrizione = "REGISTRA NUM ISCRITTI"
            } else if (_penaltyType == 'contatto') {
                data.eventoGara.descrizione = noteEvento
            } else if (_penaltyType == 'foto') {
                if (this.pettoraleIns == '') {
                    data.eventoGara.destinatorio = "GEN "+ dayjs(new Date()).format('HH:mm:ss');
                }
                data.eventoGara.descrizione = noteEvento
                data.eventoGara.imageContent = this.image
            }

            this.creaEventoGara(data).then(
                (response) => {
                    //console.log(response);
                    if (response.esito == 'OK') {
                        this.execute(this);
                        this.lastBib += this.pettoraleIns + ", ";
                        this.pettoraleIns = ''

                        /*if (this.lastEvento == 'green') {
                            alert("Partenza registrata")
                        } */
                        if (this.penaltyType !== 'blue') this.showPinpad = false
                        if (this.penaltyType == 'foto') {
                            alert ("Foto salvata con successo")
                            this.showSelected = false;
                            this.showSelectedPenalty = false;
                        }

                    } else {
                        alert(response.messaggio)
                        this.pettoraleIns = '';
                    }


                }
            ).catch(
                (error) => {
                    console.log("Error")
                });
        },

        selezionaEvento(item) {
            this.selectedItem = item;
            console.log(this.selectedItem);
            this.showSelected = true;
        },

        selezionaEventoBlu(item) {
            this.selectedItem = item;
            console.log(this.selectedItem);
            this.showSelectedPenalty = true;
        },

        modEvento(item, descrizione, stato) {
            let data =
            {
                "eventoGara": {
                    "id": item.id,
                    "modificatore": this.user,
                    "stato": stato,
                    "note": descrizione
                }

            }

            /* if (descrizione !== undefined) {
                 data.eventoGara.descrizione += "("+descrizione+")"
             }*/

            this.aggiornaEventoGara(data).then(
                (response) => {
                    //console.log(response);
                    if (response.esito == 'OK') {
                        this.execute(this);
                    } else {
                        alert(response.messaggio)
                    }

                    this.showSelected = false;
                    this.showSelectedPenalty = false;

                    // 


                }
            ).catch(
                (error) => {
                    console.log("Error")
                });
        },

        notaEvento(item) {
            if (this.selectedRace == undefined) return;
            let nota = prompt("Inserisci una nota");
            console.log(nota)
            if (nota !== null && nota.length > 0) {
                this.modEvento(item, nota, item.stato)
            }

        },

        finePitStop(item) {
            this.modEvento(item, undefined, "END_PENALTY")
        },

        avviaTimerPitStop(item) {
            let ts = dayjs(new Date()).add(item.seconds, "seconds").format('HH:mm:ss');

            this.modEvento(item, undefined , "START_PENALTY_"+ts)

        },



        cancEvento(item) {
            if (this.selectedRace == undefined) return;

            const _penaltyType = item.tipo;
            let orig = this.user;
            if (this.isAdmin()) orig = "admin";

            let data =
            {
                "eventoGara": {
                    "id": item.id,
                    "originatore": orig
                }

            }

            this.eliminaEventoGara(data).then(
                (response) => {
                    //console.log(response);
                    if (response.esito == 'OK') {
                        this.execute(this);
                    } else {
                        alert(response.messaggio)

                    }

                    this.showSelected = false;



                }
            ).catch(
                (error) => {
                    console.log("Error")
                });
        },


        insCifra(cifra) {
            if (cifra === 'CANC') {
                if (this.pettoraleIns.length > 0)
                    this.pettoraleIns = this.pettoraleIns.substring(0, this.pettoraleIns.length - 1);
            } else if (cifra == 'INVIO') {
                if (this.pettoraleIns.length > 0) {
                    this.insEvento(this.penaltyType, this.violationType);
                } else {
                    alert("Inserire il numero di pettorale")
                }
            } else {
                this.pettoraleIns = this.pettoraleIns + cifra;
            }
        },

        insAmmonizionePenalty(){
            this.penaltyAmmonizione = this.selectedTime;
            this.showPinpad = false;
            this.showViolations = true;

        },

        insAmmonizionePenaltyOK(_violationType){
            this.penaltyAmmonizione = this.selectedTime;
            this.showViolations = false;
            this.violationType = _violationType;
            this.insCifra('INVIO')
        },

        insAmmonizioneNOPenalty(){
            this.penaltyAmmonizione = 0;
            this.insCifra('INVIO')
        },

        regIscritti() {
            let numIs = prompt("Inserisci numero iscritti");
            const numIscr = parseInt(numIs);
            if (numIscr > 0) {
                this.pettoraleIns = numIscr;
                this.insEvento('regiscritti');
            }
        },

        loadEvento() {

            let data =
            {
                "eventoGara": {
                    "idManifestazione": "configRace",
                    "idGara": this.raceID
                }

            }

            this.getEventiGara(data).then(
                (response) => {
                    //console.log(response);
                    if (response.esito == 'OK') {
                        this.raceList = [];
                        let elenco = response.elencoEventiGara
                        elenco.forEach(el => {
                            if (el.tipo == 'configGara' && el.descrizione == 'raceId') {
                                this.raceList.push(el.destinatorio)
                                console.log("aggiunto 1")
                            } else if (el.tipo == 'tipoGara') {
                                if (el.descrizione == "SPRINT"){
                                    this.selectedTime = 10;
                                    this.selectedTimeMax = 60;
                                } else if (el.descrizione ==  "OLIMPICO"){
                                    this.selectedTime = 15;
                                    this.selectedTimeMax = 120;
                                } else if (el.descrizione ==  "MEDIO"){
                                    this.selectedTime = 30;
                                    this.selectedTimeMax = 300;
                                } else if (el.descrizione ==  "LUNGO"){
                                    this.selectedTime = 60;
                                    this.selectedTimeMax = 300;
                                } 
                            }

                        })

                        if (this.raceList.length == 0 && !this.isAdmin()) {
                            alert("Evento non configurato");
                            return;
                        }

                        this.configOK = true;

                        this.raceTitle = this.paramID;
                        this.myInterval = setInterval(this.refresh, this.refreshData, this);

                        this.myIntervalBar = setInterval(this.refreshBar, 1000, this);

                        if (this.currentPage !== 'login') {
                            let pref = helper.ls.get('GIUDICIAPP');
                            let sel = this.raceList.find(element => element == pref["selectedRace_" + this.raceID]);
                            console.log("trovato:" + sel)
                            if (sel != undefined) {
                                this.selezionaGara(pref["selectedRace_" + this.raceID])
                            } else {
                                this.gotoRaces()
                            }



                        } else {
                            console.log("LOGIN required");
                            this.currentPage = 'login'
                        }


                    }
                }
            ).catch(
                (error) => {
                    console.log("Error")
                });


        },

        loadEvento2() {

            console.log(this.raceID);
            const _url = this.getDataURL() + "getFile?idGara=" + this.raceID + "&fileName=remoteLiveConfiguration" + this.raceID + "_" + this.paramID + ".txt";;
            //  if (this.local) _url = "/local/"+ this.raceID+"/localLiveConfiguration" + this.raceID + "_" + this.paramID + ".csv";
            console.log(_url);
            this.getRemoteService(_url).then((response) => {
                console.log(">>" + (response) + "<<");
                if (response !== '') {
                    this.configRace(response);
                } else {
                    //alert("Evento non configurato.");
                    this.configEvento = {}

                    if (this.local !== undefined) {
                        const toks = this.local.split(",");
                        toks.forEach(tok => {
                            if (tok.indexOf("=") !== -1) {
                                const keyval = tok.split("=");
                                this.configEvento[keyval[0]] = this.normalize(keyval[1]);
                            }
                        })
                    }
                }

            }); //fine
        },

        configRace(response) {
            this.configEvento = this.properties2Object(response);
            this.configOK = true;

            if (this.local !== undefined) {
                const toks = this.local.split(",");
                toks.forEach(tok => {
                    if (tok.indexOf("=") !== -1) {
                        const keyval = tok.split("=");
                        this.configEvento[keyval[0]] = this.normalize(keyval[1]);
                    }
                })
            }

            if (this.configEvento.liveTemplate !== undefined) {
                let _url = "/" + this.configEvento.liveTemplate + "/" + this.raceID + "/" + this.paramID;
                if (this.local !== undefined) _url += "/" + this.local;
                this.$router.push(_url);
                return;
            }

            this.color = this.configEvento.color !== undefined ? this.configEvento.color : 'red';
            this.baseColor = this.configEvento.baseColor !== undefined ? this.configEvento.baseColor : this.baseColor;
            this.refreshData = (this.configEvento.refreshData !== undefined) ? parseInt(this.configEvento.refreshData) * 1000 : 60000;

            if (this.configEvento.raceList !== undefined) {
                this.raceList = this.configEvento.raceList.split(",")
            }

            this.raceTitle = this.configEvento['raceTitle'];
            this.myInterval = setInterval(this.refresh, this.refreshData, this);

            this.myIntervalBar = setInterval(this.refreshBar, 1000, this);

            if (this.currentPage !== 'login') {
                let pref = helper.ls.get('GIUDICIAPP');
                let sel = this.raceList.find(element => element == pref["selectedRace_" + this.raceID]);
                console.log("trovato:" + sel)
                if (sel != undefined) {
                    this.selezionaGara(pref["selectedRace_" + this.raceID])
                } else {
                    this.gotoRaces()
                }

            } else {
                console.log("LOGIN required");
                this.currentPage = 'login'
            }

        },

        isAdmin() {
            if (this.token == 'masterfitri') return true;

            return false;
            //if (this.configEvento.admin !== undefined && this.configEvento.admin == 'admin123') return true;
            //return this.configEvento.admin !== undefined && this.configEvento.admin === ((this.raceID + this.paramID).split("").reverse().join(""));
        },
        selezionaGara(item) {
            this.selectedRace = item;
            this.currentPage = 'event'

            this.numeroTotaleIscritti = 0
            this.numeroTotaleAssenti = 0
            this.numeroTotaleRitirati = 0
            this.numeroTotaleSqualificati = 0
            this.numeroTotaleAmmoniti = 0

            var pref = helper.ls.get('GIUDICIAPP');
            if (pref != undefined) {
                pref["selectedRace_" + this.raceID] = item;
                helper.ls.set('GIUDICIAPP', pref);
                this.refresh(this)
            } else {
                alert("Errore login non valida")
            }
        },

        refreshAll() {
            clearInterval(this.myInterval);
            clearInterval(this.myIntervalBar);
            //alert("Riavvio pagina")
            window.location.reload();

        },

        accedi() {
            if (this.loginField != undefined && this.loginField != '') {
                helper.ls.set('GIUDICIAPP', { user: this.loginField });
                this.user = this.loginField;
                this.gotoRaces();
            } else {
                alert("Errore login non valida")
            }
        },


        showCartellini() {


            this.currentPage = 'cartellini'

        },

        hideCartellini() {
            this.currentPage = 'event'
            //this.cartellini = false;
        },

        showPenalty() {
            this.currentPage = 'penalty'
        },

        showAssenti() {
            this.currentPage = 'assenti'
        },

        showRitirati() {
            this.currentPage = 'ritirati'
        },

        showContatti() {
            this.currentPage = 'contatti'
        },

        showStorico() {
            this.currentPage = 'storico'
        },

        showFoto() {
            this.currentPage = 'foto'
        },

        showRiepilogo() {
            this.currentPage = 'riepilogo'
        },

        showPartenze() {
            this.currentPage = 'partenze'
        },

        getColor(item) {
            let col = item.tipo;

            if (col == 'regiscritti') {
                return "orange black--text"
            } else   if (col == 'contatto') {
                return "pink white--text"
            } else   if (col == 'foto') {
                return "teal lighten-4 black--text"
            }


            if (col == 'white' || col == 'yellow')
                col += " black--text";
            else
                col += ' darken-2 white--text'

            return col;
        },


        refresh: function (self) {
            self.execute(self);
        },

        refreshBar: function (self) {
            if (self.pause) return;
            if (self.value == undefined) self.value = 0;
            // console.log("refreshBar :" + self.value)
            self.value += (100 / (self.refreshData / 1000));
            //console.log(self.value);
            if (self.value > 100) self.value = 0;

            let _temp = [];

            this.itemsBLUExecuting.forEach(item => {

                let sec = item.stato.replace("START_PENALTY_", "")

                item.end = this.diffSeconds(sec, dayjs().format('HH:mm:ss'))
                if (item.end < 0) {
                    item.end = 0
                }
                _temp.push(item)
            })
            this.itemsBLUExecuting = _temp;

            //const now = dayjs(new Date()).format('HH:mm:ss');
            //this.raceTime = this.diffTime(now, this.configEvento.gunTime)
        },

        forceReload() {
            this.refresh(this);
        },

        isGA() {
            return this.token == 'ga' || this.isAdmin()
        },


        removeUndefined(value) {
            if (value == undefined) return "";
            return value;
        },

        creaGara() {
            let nomeGara = prompt("Nome divisione")
            if (nomeGara !== undefined) {

                let data =
                {
                    "eventoGara": {
                        "idManifestazione": "configRace",
                        "idGara": this.raceID,
                        "tipo": "configGara",
                        "descrizione": 'raceId',
                        "originatore": this.user,
                        "stato": "INS",
                        "destinatorio": nomeGara,
                        "note": ""
                    }

                }

                this.creaEventoGara(data).then(
                    (response) => {
                        //console.log(response);
                        if (response.esito == 'OK') {
                            this.executeConfig(this);
                        } else {
                            alert(response.messaggio)
                        }
                    }
                ).catch(
                    (error) => {
                        console.log("Error")
                    });
            }
        },

        impostaTipoGara(tipoGara) {
                const dest = dayjs(new Date()).format('HHmmss');


                let data =
                {
                    "eventoGara": {
                        "idManifestazione": "configRace",
                        "idGara": this.raceID,
                        "tipo": "tipoGara",
                        "descrizione": tipoGara,
                        "originatore": this.user,
                        "stato": "INS",
                        "destinatorio": dest,
                        "note": ""
                    }

                }

                this.creaEventoGara(data).then(
                    (response) => {
                        //console.log(response);
                        if (response.esito == 'OK') {
                            this.execute(this);
                            alert("Operazione registrata")
                        } else {
                            alert(response.messaggio)
                        }
                    }
                ).catch(
                    (error) => {
                        console.log("Error")
                    });
        },


        execute(self) {
            //if (self.selectedRace == undefined) return;
            let data =
            {
                "eventoGara": {
                    "idManifestazione": this.selectedRace,
                    "idGara": this.raceID
                }

            }

            self.getEventiGara(data).then(
                (response) => {
                    //console.log(response);
                    if (response.esito == 'OK') {
                        let elenco = response.elencoEventiGara

                        this.numeroTotaleIscritti = 0
                        this.numeroTotaleAssenti = 0
                        this.numeroTotaleRitirati = 0
                        this.numeroTotaleSqualificati = 0
                        this.numeroTotaleAmmoniti = 0

                        elenco.forEach(el => {
                            let ts = moment(el.tmsOrigine).format("HH:mm:ss");
                            el['orario'] = ts;

                            if (el.tipo == 'yellow') this.numeroTotaleAmmoniti++;
                            else if (el.tipo == 'red') this.numeroTotaleSqualificati++;


                            if (el.tipo == 'regiscritti') {
                                this.numeroTotaleIscritti = parseInt(el.destinatorio)
                                el.destinatorio = "*";
                            }

                            if (el.tipo == 'tipoGara') {
                                if (el.descrizione == "SPRINT"){
                                    this.selectedTime = 10;
                                    this.selectedTimeMax = 60;
                                } else if (el.descrizione ==  "OLIMPICO"){
                                    this.selectedTime = 15;
                                    this.selectedTimeMax = 120;
                                } else if (el.descrizione ==  "MEDIO"){
                                    this.selectedTime = 30;
                                    this.selectedTimeMax = 300;
                                } else if (el.descrizione ==  "LUNGO"){
                                    this.selectedTime = 60;
                                    this.selectedTimeMax = 300;
                                } 
                            }
                        })

                        this.items = elenco.reverse();

                        this.itemsF = this.items;

                        this.itemsCartellini = this.items.filter(p => {
                            return (p.tipo == 'yellow' || p.tipo == 'red' || p.tipo == 'blue');
                        })

                        this.itemsBLU = this.items.filter(p => {
                            const cond1 =  (p.tipo == "blue" && (p.stato != 'END_PENALTY' && !p.stato.startsWith('START_PENALTY'))) ;
                            const cond2 = (p.tipo == "yellow" && p.stato.startsWith('PENALTY_') ) ;
                            return cond1 || cond2;
                        })
                        this.itemsBLU.forEach(item => {
                            let sec = item.stato.replace("PENALTY_", "")
                            item.seconds = parseInt(sec)
                        })

                        this.itemsBLUExecuted = this.items.filter(p => {
                            return ( (p.tipo == "blue"  || p.tipo == "yellow") && p.stato == 'END_PENALTY');
                        })

                        this.itemsBLUExecuting = this.items.filter(p => {
                            return ((p.tipo == "blue"  || p.tipo == "yellow") && p.stato.startsWith('START_PENALTY'));
                        })
                        this.itemsBLUExecuting.forEach(item => {

                            let sec = item.stato.replace("START_PENALTY_", "")

                            item.end = this.diffSeconds(sec, dayjs().format('HH:mm:ss'))
                          


                        })

                        this.itemsAssenti = this.items.filter(p => {
                            return (p.tipo == "white");
                        }).sort((a, b) => {
                            return a.destinatorio - b.destinatorio
                        }).filter((v, i, a) => a.findLastIndex(v2 => (v2.destinatorio === v.destinatorio)) === i)


                        this.itemsRitirati = this.items.filter(p => {
                            return (p.tipo == "grey");
                        }).sort((a, b) => {
                            return a.destinatorio - b.destinatorio
                        }).filter((v, i, a) => a.findLastIndex(v2 => (v2.destinatorio === v.destinatorio)) === i)

                        this.itemsPartenze = this.items.filter(p => {
                            return (p.tipo == "green");
                        })

                        this.itemsContatti = this.items.filter(p => {
                            return (p.tipo == "contatto");
                        })

                        this.itemsFoto = this.items.filter(p => {
                            return (p.tipo == "foto");
                        })

                        this.itemsFoto.forEach( item => {
                            if (item.destinatorio.startsWith("GEN")) {
                                item.destinatorio = "GEN"
                            }
                        })


                        this.numeroTotaleRitirati = this.itemsRitirati.length;
                        this.numeroTotaleAssenti = this.itemsAssenti.length;
                        this.numeroTotalePartiti = this.numeroTotaleIscritti - this.numeroTotaleAssenti;

                    }
                    this.loaded = true;
                }
            ).catch(
                (error) => {
                    console.log("Error")
                });
        },


        executeConfig(self) {
            //if (self.selectedRace == undefined) return;
            let data =
            {
                "eventoGara": {
                    "idManifestazione": this.selectedRace,
                    "idGara": this.raceID
                }

            }

            self.getEventiGara(data).then(
                (response) => {
                    //console.log(response);
                    if (response.esito == 'OK') {

                        this.raceList = [];

                        let elenco = response.elencoEventiGara

                        elenco.forEach(el => {
                            if (el.tipo == 'configGara') {
                                this.raceList.push(el.destinatorio)
                            } else    if (el.tipo == 'tipoGara') {
                                if (el.descrizione == "SPRINT"){
                                    this.selectedTime = 10;
                                    this.selectedTimeMax = 60;
                                } else if (el.descrizione ==  "OLIMPICO"){
                                    this.selectedTime = 15;
                                    this.selectedTimeMax = 120;
                                } else if (el.descrizione ==  "MEDIO"){
                                    this.selectedTime = 30;
                                    this.selectedTimeMax = 300;
                                } else if (el.descrizione ==  "LUNGO"){
                                    this.selectedTime = 60;
                                    this.selectedTimeMax = 300;
                                } 
                            }

                        })
                    }
                }
            ).catch(
                (error) => {
                    console.log("Error")
                });
        },



        gotoHome() {
            this.currentPage = 'event'
        },

        gotoRaces() {
            this.selectedRace = "configRace"
            this.currentPage = 'races'
            this.showImpostazioni = false;
        },


        gotoAdmin() {
            this.$router.push('/admin');
        },

        getStyle(index, n) {
            if (n != undefined) return n;
            if (index % 2 == 0) return "grey lighten-4"
            return "white"
        },

     



        filterState(tipoFiltro) {
            console.log("Applico filtro: " + tipoFiltro)
            console.log(this.items)
            if (tipoFiltro == 'iscritti') {
                this.itemsF = this.items;
            } else if (tipoFiltro == 'ritirati') {
                this.itemsF = this.items.filter(p => {
                    return p.tipo == "grey"
                })
            } else if (tipoFiltro == 'assenti') {
                this.itemsF = this.items.filter(p => {
                    return p.tipo == "white"
                })
            } else if (tipoFiltro == 'squalificati') {
                this.itemsF = this.items.filter(p => {
                    return p.tipo == "red"
                })
            } else if (tipoFiltro == 'ammoniti') {
                this.itemsF = this.items.filter(p => {
                    return p.tipo == "yellow"
                })
            }
        }







    },
};
</script>
    
<style scoped>
td {
    height: 10px !important;
    _background-image: linear-gradient(60deg, grey, lightgray);
}

table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child) {
    padding: 0 10px;
}

.frazioniTitle {
    text-align: center;
    background-color: lightgrey;
    border-radius: 0px 0px 3px 3px;
}

.frazioniValue {
    text-align: center;
    background-color: white;
    border-radius: 0px 0px 3px 3px;
    border-bottom: 1px solid lightgray;
}

.frazioniValueR {
    text-align: right !important;
}

.frazioniTitleFinale {
    text-align: center;
    color: white;
    font-style: italic;
    _border: 1px solid lightgray;
    _border-radius: 0px 0px 7px 7px;
    _font-weight: bold;
}

.frazioniTitleFinaleDesk {
    text-align: center;
    color: white;
    font-style: italic;
    _border-radius: 0px 5px 5px 0px;
}

.frazioniTitleRow {
    text-align: center;
    background-color: lightgrey;
    _border-radius: 0px 0px 7px 7px;
}

.frazioniTitleRowDesk {
    text-align: center;
    background-color: lightgrey;
    _border-radius: 5px 0px 0px 5px;
}

.frazioniValueRow {
    text-align: center;
    background-color: rgb(243, 243, 243);
    _border-radius: 0px 0px 7px 7px;
}

.passaggio {
    background-color: lightgrey;
    text-align: center;
    color: green;
    font-style: italic;
    _border: 1px solid lightgray;
    border-radius: 5px 5px 5px 5px;
    _font-weight: bold;
}

.laps {
    text-align: center;
    color: white;
    font-style: italic;
}

.clock {
    background-color: #212121;
    text-align: center;
    color: white;
    font-style: italic;
}

.cardUp {
    background-color: #212121;
    color: white;
    _border: 1px solid lightgray;
    border-radius: 10px 10px 0px 0px;
}

.cardStatsHeader {
    background-color: #212121;
    color: white;
    border-radius: 10px 10px 0px 0px;
}

.cardStats {
    background-color: white;
    color: black;
    border: 2px solid lightgray;
    border-radius: 10px 10px 10px 10px;
}

.v-text-field {
    color: red;
    border-color: rgba(192, 0, 250, 0.986);
}</style>
    